module.exports = __webpack_public_path__ + "static/media/nationality.b89806e2.svg";